"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableFade = void 0;
var expandable_fade_1 = require("@csod/expandable-fade");
exports.ExpandableFade = expandable_fade_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["ExpandableFade"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ExpandableFade/ExpandableFade.js
// module id = 727
// module chunks = 0